<div class="notification-page-container" *ngIf="!isLabelsLoading && !isAccordionLoading">
	<div
		class="main-col"
		[ngClass]="{ 'focus-view': selectedAccordion && selectedNotification.id === '' }"
		[ngStyle]="{ width: ghostResizeBar.mainCol + '%' }">
		<div class="accordion-col" [ngStyle]="{ left: selectedAccordion.id === '' ? '0' : '-100%' }">
			<div class="title">{{ labels.lbl_geral_notificacoes }}</div>

			<div class="accordion-container">
				<div
					class="accordion color-{{ index % 6 }}"
					*ngFor="let accordion of notificationAccordion; let index = index"
					(click)="selectedAccordion = accordion">
					<div>
						<span>{{ accordion.name }}</span>
					</div>
					<div class="accordion-length color-{{ index % 6 }}">
						{{
							accordion.notification.length <= 9
								? '000' + accordion.notification.length
								: accordion.notification.length <= 99
									? '00' + accordion.notification.length
									: accordion.notification.length <= 999
										? '0' + accordion.notification.length
										: accordion.notification.length
						}}
					</div>
				</div>
			</div>
		</div>

		<div class="last-upload-col" [ngStyle]="{ left: selectedAccordion.id === '' ? '100%' : '0' }">
			<div class="navigation">
				<span (click)="cleanNotificationAccordion(); changeHistory('/notification')">< {{ labels.lbl_geral_notificacoes }}</span>
				<span>< {{ selectedAccordion.name }}</span>
			</div>

			<div class="title">{{ selectedAccordion.name }}</div>

			<div class="accordion-container">
				<div class="card" *ngIf="selectedAccordion.notification.length == 0">
					<span>{{ labels.lbl_geral_nao_existem_notificacoes }}</span>
				</div>
				<div
					class="card"
					*ngFor="let notification of selectedAccordion.notification"
					[ngClass]="{ warning: isCardNewNotification(notification.id) }"
					(click)="selectNotification(notification.id); secondColView = 'notification'">
					<span class="bold">{{ notification.summary }}</span>
					<span>{{ formartDescription(notification.description) }}</span>
				</div>
			</div>
		</div>
	</div>

	<div
		class="sub-col"
		[ngClass]="{ 'focus-view': selectedNotification && selectedNotification.id && selectedNotification.id !== '' }"
		[ngStyle]="{ width: ghostResizeBar.subCol + '%' }">
		<div class="notification-col" *ngIf="secondColView === 'notification'">
			<div class="title">{{ selectedNotification.summary }}</div>
			<div class="body" [innerHTML]="selectedNotification.description"></div>
		</div>

		<div
			class="not-chosen-col"
			[ngClass]="{ loading: secondColView === 'loading' }"
			*ngIf="secondColView === 'not-chosen' || secondColView === 'loading'">
			<cpi-svg-gears [gearSpinDurationMS]="10000"></cpi-svg-gears>
			<div>{{ secondColView === 'not-chosen' ? labels.lbl_selecione_uma_opcao : labels.lbl_edocs_carregando }}</div>
		</div>

		<div class="ghost-resize-bar" (mousedown)="ghostResizeBar.mouseDown = true"></div>
	</div>
</div>

<div class="loading-container" *ngIf="isLabelsLoading || isAccordionLoading">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
